import { createContext } from "react";

export default createContext({
  edpServices: [],
  error: null,
  pending: true,
  selectEdpService: () => {},
  selectedEdpService: null,
});
